<template>
    <form @change="sendDataForSaving" ref="personalDetails">
        <div class="row">
            <ValidationProvider
                name="First Name"
                rules="required|latin|min:2|max:100"
                class="col-lg-4"
                v-slot="{ errors }"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">First name</label>
                    <input type="text"
                           class="form-control"
                           v-model="form.name">
                    <FormError
                        :error="errors[0]"
                        name="First Name"
                    ></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                name="Middle Name"
                rules="latin|min:2|max:100"
                v-slot="{ errors }"
                class="col-lg-4"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Middle Name</label>
                    <input type="text"
                           class="form-control"
                           v-model="form.middle_name">
                    <FormError :error="errors[0]" name="Middle Name"></FormError>
                </div>
            </ValidationProvider>


            <ValidationProvider name="Last Name"
                                rules="required|latin|min:2|max:100"
                                class="col-lg-4"
                                v-slot="{ errors }">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Last name</label>
                    <input type="text"
                           class="form-control"
                           v-model="form.last_name">
                    <FormError :error="errors[0]" name="Last Name"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider name="Date of birth"
                                rules="required"
                                v-slot="{errors}"
                                class="col-lg-4">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Date of Birth</label>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-1 mb-0">
                                <date-picker
                                    style="width: 100%;"
                                    v-model="form.birth_date"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    @close="calculateAge"
                                ></date-picker>

                                <div v-if="form.age <18" style="color: darkred">All applicants need to be at least 18
                                    years old for eligibility
                                </div>
                                <FormError :error="errors[0]" name="Date of birth"></FormError>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider name="Email"
                                rules="required|email"
                                v-slot="{ errors }"
                                class="col-lg-8">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Email (if any)</label>
                    <input type="email"
                           class="form-control"
                           v-model="form.email">
                    <FormError :error="errors[0]" name="Email"></FormError>
                </div>
            </ValidationProvider>


        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group form-group-1">
                    <label for="home_phone" class="form-label">Home Phone</label>
                    <input type="text"
                           class="form-control"
                           id="home_phone"
                           v-mask="'(###) ###-####'"
                           v-model="form.home_number">
                </div>
            </div>
            <ValidationProvider name="Phone number"
                                v-slot="{ errors }"
                                class="col-lg-4"
                                rules="required|customMin:17">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Cell Phone</label>
                    <input type="text"
                           class="form-control"
                           v-mask="'+1 (###) ###-####'"
                           v-model="form.cell_number">
                    <FormError :error="errors[0]" name="Phone number"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider class="col-lg-4" name="SSN" rules="required|customMin:11" v-slot="{ errors }">
                <div class="form-group form-group-1">
                    <div class="form-group form-group-1 mb-0">
                        <label for="" class="form-label">Social Security Number</label>
                        <input
                            type="text"
                            class="form-control"
                            v-mask="'### ## ####'"
                            v-model="form.ssn"
                        >
                        <FormError :error="errors[0]" name="SSN"></FormError>
                    </div>
                </div>
            </ValidationProvider>
        </div>
        <div class="row align-items-end">

            <div class="col-lg-12">
                <div class="form-group form-group-1">
                    <div class=" drag-drop">
                        <div class="before-text">
                            <label for="file-upload" class="custom-file-upload label-input icon upload-link">
                                <span id="file-name">UPLOAD RESUME</span>
                                <span class="icon-input"></span>
                                <input
                                    id="file-upload"
                                    accept="application/pdf, application/msword, application/docx , application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    type="file"
                                    multiple
                                    class="icon"
                                    @change="selectFiles"
                                    ref="files"
                                >
                            </label>
                        </div>
                    </div>
                    <div v-if="this.filesInfo.length > 0" class="drag-drop drag-drop-after">
                        <div
                            class="uploaded-file"
                            v-for="(file, index) in filesInfo"
                            :key="index"
                        >
                            <i class="fas fa-file file"></i>
                            <a :href="`/uploads/${file.file_path}`"
                               title="Download"
                               :download="`${file.original_filename}`">
                              <span :title="file.original_filename" class="file-name">
                                    {{ file.original_filename }}
                                </span>
                            </a>

                            <a
                                href="javascript:void(0)"
                                class="delete"
                                @click="deleteFile(file.id)"
                            >
                                <i class="fas fa-times"></i>
                            </a>
                        </div>
                    </div>
                    <div v-else class="drag-drop drag-drop-after " style="font-size: 12px">
                        * please upload only .pdf /.docx files
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import MaskedInput from "vue-text-mask";
import PersonalDetailsService from "../services/PersonalDetailsService";

export default {
    name: 'PersonalDetailsForm',
    components: {
        MaskedInput,
    },
    props: {
        user: {
            type: Object,
        }
    },
    data() {
        return {
            form: {
                name: null,
                middle_name: null,
                last_name: null,
                email: null,
                home_number: null,
                cell_number: null,
                resume_ids: [],
                retype_cell_number: null,
                ssn: null,
                age: null,
                birth_date: null
            },
            filesInfo: [],
            files: [],
        }
    },
    methods: {
        calculateAge() {
            const bd = new Date(this.form.birth_date);
            const today = new Date();
            const diff = today.getTime() - bd.getTime()
            const age = (diff / 31536000000).toFixed()
            this.form.age = age
        },
        async deleteFile(id) {
            this.filesInfo = this.filesInfo.filter((item) => item.id !== id)
            this.form.resume_ids = this.form.resume_ids.filter((item) => item.id !== id)
            try {
                await PersonalDetailsService.delete(id);
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        getFilesId() {
            this.form.resume_ids = [];
            let newFiles = this.filesInfo;
            for (let i = 0; i < newFiles.length; i++) {
                this.form.resume_ids.push(newFiles[i].id);
            }
        },

        async readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        async selectFiles(event) {
            const uploadedFiles = this.$refs.files.files;
            const files = await Promise.all(
                Array.from(uploadedFiles).map(async (file) => {
                    try {
                        const content = await this.readFileAsync(file);
                        return {
                            file,
                            name: file.name,
                            content,
                        };
                    } catch (error) {
                        console.error("Error reading file:", error);
                        return null;
                    }
                })
            );
            this.files = [...new Map([...this.files, ...files].map(item => [item.name, item])).values()];

            await this.sendFiles(this.files);
        },
        async sendFiles(files) {
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append('files[]', files[i].file)
            }
            try {
                const {data: filesInfo} = await PersonalDetailsService.getFilesInfo(this.user.id, formData);
                this.filesInfo = [...this.filesInfo, ...filesInfo]
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        setData() {
            for (const userKey in this.user) {
                for (const formKey in this.form) {
                    if (userKey === formKey) {
                        this.form[userKey] = this.user[formKey];
                    }
                }
            }
        },
    },

    mounted() {
        this.setData();
        this.calculateAge();
        this.sendDataForSaving()

        if (this.user.resumes.length > 0) {
            const restructuredArray = this.user.resumes.map(item => ({
                original_filename: item.original_filename,
                id: item.id,
                file_path: item.file_path,
            }));

            this.filesInfo = [...this.filesInfo, ...restructuredArray]
        }
    },
    watch: {
        filesInfo: {
            handler: 'getFilesId',
            deep: true
        }
    },


}

</script>

<style scoped>
.mx-datepicker .mx-input {
    height: 2.8rem ;
}

.custom-file-upload {
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}

.custom-file-upload input[type="file"] {
    display: none;
}

.label-input {
    margin: 0;
}

.icon-input {
    background-image: url(/uploads/img/svg/icons-upload.svg);
    background-repeat: no-repeat;
    margin: 10px 10px;
    position: relative;
    display: inline-block;
    width: 16px;
    height: 16px;
}

.uploaded-file {
    width: 6rem !important;
    height: 6.5rem !important;
}

.file-name {
    font-size: small;
    text-align: center;
}

.drag-drop-after {
    margin: 5px 0;
}

</style>
